"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useIntegrations(query) {
  const { ...rest } = useElements("integrations", query);
  return {
    integrations: rest.items,
    ...rest
  };
}

export { useIntegrations };
